export const remainingMessages = {
  "TÚ": [
    "YOU",
    "VOCÊ"
  ],
  "Tu": [
    "Your",
    "Seu"
  ],
  "Ver implementación técnica": [
    "View technical implementation",
    "Ver implementação técnica"
  ],
  "días": [
    "days",
    "dias"
  ],
  "/sem": [
    "/week",
    "/semana"
  ],
  "users": [
    "users",
    "usuários"
  ],
  "J05 · TÉCNICO": [
    "J05 · TECHNICAL",
    "J05 · TÉCNICO"
  ],
  "J08 · REPUTACIÓN": [
    "J08 · REPUTATION",
    "J08 · REPUTAÇÃO"
  ],
  "FASE 02 · OPTIMIZACIÓN": [
    "PHASE 02 · OPTIMIZATION",
    "FASE 02 · OTIMIZAÇÃO"
  ],
  "\"¿Qué conviene a una empresa mediana que recién empieza a medir su visibilidad en IA?\"": [
    "\"What should a medium-sized business use to start measuring AI visibility?\"",
    "\"O que uma empresa de médio porte deve usar para começar a medir sua visibilidade em IA?\""
  ],
  "¿Por dónde empiezo a medir mi visibilidad en los motores de IA?": [
    "Where should I start measuring my visibility in AI engines?",
    "Por onde começo a medir minha visibilidade nos motores de IA?"
  ],
  "Respuesta de 80 a 120 palabras, con el dato, su fuente y tu propuesta, escrita para poder citarse sola.": [
    "An 80–120 word answer with the data, source and your proposition, written to be cited on its own.",
    "Resposta de 80–120 palavras com os dados, a fonte e sua proposta, escrita para ser citada de forma independente."
  ],
  "es la opción más conocida de la categoría y destaca por su cobertura nacional.": [
    "is the best-known option in the category, with strong nationwide coverage.",
    "é a opção mais conhecida da categoria, com forte cobertura nacional."
  ],
  "ofrece planes más flexibles y soporte en español; varios clientes la recomiendan para empresas medianas.": [
    "offers more flexible plans and Spanish support; several customers recommend it for medium-sized businesses.",
    "oferece planos mais flexíveis e suporte em espanhol; vários clientes a recomendam para empresas de médio porte."
  ],
  "conviene si buscas el precio más bajo, aunque con menos integraciones.": [
    "is a good fit for the lowest price, with fewer integrations.",
    "é uma boa opção para o menor preço, com menos integrações."
  ],
  "Un reporte ejecutivo con lo que cambió y por qué.": [
    "An executive report on what changed and why.",
    "Um relatório executivo sobre o que mudou e por quê."
  ],
  "Avisos competitivos cuando cambia tu posición frente a la competencia.": [
    "Competitive alerts when your position changes against competitors.",
    "Alertas competitivos quando sua posição muda frente à concorrência."
  ],
  "En Slack, en Teams o por webhooks hacia tus propios sistemas.": [
    "In Slack, Teams or via webhooks to your own systems.",
    "No Slack, Teams ou por webhooks para seus próprios sistemas."
  ],
  "Prompts únicos / semanal": [
    "Unique prompts / week",
    "Prompts únicos / semana"
  ],
  "Frecuencia de medición": [
    "Measurement frequency",
    "Frequência de medição"
  ],
  "Tráfico Humano vs IA (GA4)": [
    "Human vs AI traffic (GA4)",
    "Tráfego humano e de IA (GA4)"
  ],
  "Score AEO 0–100 y diagnóstico 4D": [
    "AEO Score 0–100 and 4D diagnosis",
    "Score AEO 0–100 e diagnóstico 4D"
  ],
  "Respuestas analizadas / mes": [
    "Answers analyzed / month",
    "Respostas analisadas / mês"
  ],
  "Brechas detectadas por motor": [
    "Gaps detected by engine",
    "Lacunas detectadas por motor"
  ],
  "Auditoría schema + llms.txt": [
    "Schema + llms.txt audit",
    "Auditoria schema + llms.txt"
  ],
  "Brand Brain — anti-alucinación": [
    "Brand Brain — hallucination prevention",
    "Brand Brain — prevenção de alucinações"
  ],
  "Biblioteca de acciones y guías": [
    "Action and guide library",
    "Biblioteca de ações e guias"
  ],
  "Priorización por tipo de empresa": [
    "Priorities by business type",
    "Priorização por tipo de empresa"
  ],
  "Condiciones de avance configurables": [
    "Configurable progress criteria",
    "Critérios de avanço configuráveis"
  ],
  "Sesión estratégica AEO/GEO": [
    "AEO/GEO strategy session",
    "Sessão estratégica AEO/GEO"
  ],
  "Generación de contenido": [
    "Content generation",
    "Geração de conteúdo"
  ],
  "Ejecución de optimización": [
    "Optimization execution",
    "Execução da otimização"
  ],
  "Alertas competitivas en tiempo real": [
    "Real-time competitive alerts",
    "Alertas competitivos em tempo real"
  ],
  "15 / sem": [
    "15 / week",
    "15 / semana"
  ],
  "30 / sem": [
    "30 / week",
    "30 / semana"
  ],
  "50 / sem": [
    "50 / week",
    "50 / semana"
  ],
  "80 / sem": [
    "80 / week",
    "80 / semana"
  ],
  "100 / sem": [
    "100 / week",
    "100 / semana"
  ],
  "150 / sem": [
    "150 / week",
    "150 / semana"
  ],
  "200 / sem": [
    "200 / week",
    "200 / semana"
  ],
  "Cualquier motor": [
    "Any engine",
    "Qualquer motor"
  ],
  "$ 875.000 / mes": [
    "$ 875.000 / month",
    "$ 875.000 / mês"
  ],
  "$ 17,880 / año": [
    "$ 17,880 / year",
    "$ 17,880 / ano"
  ],
  "Basado en casos cerrados en LATAM. 1% de SOV perdido equivale a ~$8,400 USD anuales en leads para una empresa mediana del sector B2B.": [
    "Based on closed cases in Latin America. A 1% loss of SOV is equivalent to about USD 8,400 in annual leads for a medium-sized B2B business.",
    "Com base em casos fechados na América Latina. Uma perda de 1% de SOV equivale a cerca de USD 8.400 anuais em leads para uma empresa B2B de médio porte."
  ],
  "El 22% de las búsquedas LLM no respondidas por tu marca se convierte en una oportunidad para un competidor que sí está citado por la IA.": [
    "22% of LLM searches not answered by your brand become an opportunity for a competitor cited by AI.",
    "22% das buscas em LLMs não respondidas pela sua marca viram oportunidade para um concorrente citado pela IA."
  ],
  "Tu cifra puede variar entre 0.5× y 3× este estimado según vertical y geografía. Solicita un diagnóstico para una estimación específica.": [
    "Your figure may range from 0.5× to 3× this estimate by vertical and geography. Request a diagnosis for a specific estimate.",
    "Seu resultado pode variar de 0,5× a 3× esta estimativa conforme o setor e a região. Solicite um diagnóstico para uma estimativa específica."
  ],
  "ESPAÑOL NATIVO": [
    "NATIVE SPANISH",
    "ESPANHOL NATIVO"
  ],
  "3 motores": [
    "3 engines",
    "3 motores"
  ],
  "4 motores": [
    "4 engines",
    "4 motores"
  ],
  "+ 1 motor": [
    "+ 1 engine",
    "+ 1 motor"
  ],
  "5 motores": [
    "5 engines",
    "5 motores"
  ],
  "+ 2 motores": [
    "+ 2 engines",
    "+ 2 motores"
  ],
  "incluido en Radar": [
    "included in Radar",
    "incluído no Radar"
  ],
  "incluido en Growth": [
    "included in Growth",
    "incluído no Growth"
  ],
  "A MEDIDA": [
    "CUSTOM",
    "SOB MEDIDA"
  ],
  "{price} / MES + IVA": [
    "{price} / MONTH + VAT",
    "{price} / MÊS + IVA"
  ],
  "{count} revisiones": [
    "{count} checks",
    "{count} verificações"
  ],
  "Calcular en {currency}": [
    "Calculate in {currency}",
    "Calcular em {currency}"
  ],
  "Logo de {engine}": [
    "{engine} logo",
    "Logo de {engine}"
  ],
  "Idiomas": [
    "Languages",
    "Idiomas"
  ],
  "Competidores incluidos": [
    "Included competitors",
    "Concorrentes incluídos"
  ],
  "Reporte ejecutivo semanal": [
    "Weekly executive report",
    "Relatório executivo semanal"
  ],
  "Bison Agent integrado": [
    "Integrated Bison Agent",
    "Bison Agent integrado"
  ],
  "Account Manager dedicado": [
    "Dedicated account manager",
    "Gerente de conta dedicado"
  ],
  "Workspaces multi-marca (agencias)": [
    "Multi-brand workspaces (agencies)",
    "Workspaces de múltiplas marcas (agências)"
  ],
  "Cifrado AES-256 + TLS 1.3": [
    "AES-256 + TLS 1.3 encryption",
    "Criptografia AES-256 + TLS 1.3"
  ],
  "ISO 27001 (controles implementados)": [
    "ISO 27001 (controls implemented)",
    "ISO 27001 (controles implementados)"
  ],
  "DPA + residencia configurable": [
    "DPA + configurable data residency",
    "DPA + residência de dados configurável"
  ],
  "A elección": [
    "Your choice",
    "À escolha"
  ],
  "100 / sem · 3 + 2": [
    "100 / week · 3 + 2",
    "100 / semana · 3 + 2"
  ],
  "A elección · Growth suma 2 a los 3 base": [
    "Your choice · Growth adds 2 to the 3 base engines",
    "À escolha · o Growth soma 2 aos 3 motores base"
  ],
  "Índice": [
    "Index",
    "Índice"
  ],
  "Growth: los 3 motores base (ChatGPT, Gemini y Perplexity) más 2 a elección entre Claude, Google AIO, Meta Muse, Grok, Copilot, DeepSeek y Mistral; ~6.700 respuestas analizadas/mes. Enterprise: el set de motores se arma a medida.": [
    "Growth: the 3 base engines (ChatGPT, Gemini and Perplexity) plus 2 of your choice from Claude, Google AIO, Meta Muse, Grok, Copilot, DeepSeek and Mistral; ~6,700 responses analyzed per month. Enterprise: the engine set is built to order.",
    "Growth: os 3 motores base (ChatGPT, Gemini e Perplexity) mais 2 à escolha entre Claude, Google AIO, Meta Muse, Grok, Copilot, DeepSeek e Mistral; ~6.700 respostas analisadas por mês. Enterprise: o conjunto de motores é montado sob medida."
  ],
  "Ordenado por visibilidad y, si dos marcas empatan, por prominencia. El promedio de la industria es {avg}% de visibilidad.": [
    "Sorted by visibility and, when two brands tie, by prominence. The industry average is {avg}% visibility.",
    "Ordenado por visibilidade e, em caso de empate entre duas marcas, por proeminência. A média do setor é {avg}% de visibilidade."
  ],
  "El índice resume en un número de 0 a 100 la visibilidad (50%), el share of voice (30%) y la prominencia (20%), cada uno relativo al líder: sirve para comparar marcas dentro de esta industria, no entre industrias.": [
    "The index sums up visibility (50%), share of voice (30%) and prominence (20%) in a single number from 0 to 100, each relative to the leader: use it to compare brands within this industry, not across industries.",
    "O índice resume em um número de 0 a 100 a visibilidade (50%), o share of voice (30%) e a proeminência (20%), cada um relativo ao líder: serve para comparar marcas dentro deste setor, não entre setores."
  ],
  "Con {total} capturas, una diferencia menor a {margin} puntos entre dos marcas puede ser azar.": [
    "With {total} captures, a difference of less than {margin} points between two brands may be chance.",
    "Com {total} capturas, uma diferença menor que {margin} pontos entre duas marcas pode ser acaso."
  ],
  "Ver rankings de otros países": [
    "See rankings for other countries",
    "Ver rankings de outros países"
  ]
};
